<template>
  <div class="table-settings-presets">
    <template v-for="group in groupedPresets">
      <div
        :key="`group-header_${group.name}`"
        class="table-settings-presets__group-name"
      >
        {{ group.name }}
      </div>
      <div
        :key="`group-items_${group.name}`"
        class="table-settings-presets__items"
      >
        <TableSettingsPresetItem
          v-for="preset in group.items"
          :key="preset.id"
          :preset="preset"
          :active="activePresetId === preset.id"
          :can-edit-preset-predicate="canEditPresetPredicate"
          :can-delete-preset-predicate="canDeletePresetPredicate"
          @edit="$emit('editPreset', preset.id)"
          @delete="$emit('deletePreset', preset.id)"
          @selectPreset="$emit('selectPreset', preset.id)"
        />
      </div>
    </template>
    <div
      v-if="presetsListEmpty"
      class="table-settings-presets__not-found"
    >
      {{ _getTr("no_table_presets_found") }}
    </div>
  </div>
</template>

<script>
  import TableSettingsPresetItem from 'components/Data/TableSettings/TableSettingsPresets/TableSettingsPresetItem';
  export default {
    name: 'TableSettingsPresets',
    components: {TableSettingsPresetItem},
    props: {
      groupedPresets: {
        type: Array,
        default: Array
      },
      activePresetId: {
        type: Number,
        default: null
      },
      canEditPresetPredicate: {
        type: Function,
        default: () => true
      },
      canDeletePresetPredicate: {
        type: Function,
        default: () => true
      }
    },
    computed: {
      presetsFlat () {
        return this.groupedPresets.map(p => p.items).flat().
          filter(p => Boolean(p));
      },
      presetsListEmpty () {
        return this.presetsFlat.length === 0;
      }
    }
  };
</script>

<style>
  .table-settings-presets {
    cursor: default;

    max-width: 246px;
    min-width: 140px;

    padding-bottom: 5px;
  }

  .table-settings-presets__group-name {
    font-size: 12px;
    font-weight: var(--medium-font-weight);

    color: var(--text-main-color);

    padding-top: 12px;
    padding-left: 12px;
    padding-bottom: 4px;

    margin-right: 12px;
  }

  .table-settings-presets__not-found {
    font-size: 12px;

    color: var(--secondary-text-color);

    white-space: nowrap;

    padding: 12px 12px 7px;
  }

</style>
